module.exports = __webpack_public_path__ + "static/media/mv.2b802f91.svg";